module.exports = __webpack_public_path__ + "img/zhoujiadu-center.ab57d113.jpg";